import Vue from "vue"

/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    emailTemplate: null,
    smsTemplate: null,
    sendEmail: false,
    sendSms: false,
    delaySending: false,
    sendAt: '',
    fromEmail: '',
    toEmails: [],
    ccEmails: [],
    bccsEmails: [],
    subject: '',
    attachments: [],
    smsTextMaxLength: 320,
    emailBody: '',
    smsBody: '',
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {
    getEmailTemplate: state => {
        return state.emailTemplate
    },
    getSmsTemplate: state => {
        return state.smsTemplate
    },
    getSendEmail: state => {
        return state.sendEmail
    },
    getSendSms: state => {
        return state.sendSms
    },
    getDelaySending: state => {
        return state.delaySending
    },
    getSendAt: state => {
        return state.sendAt
    },
    getFromEmail: state => {
        return state.fromEmail
    },
    getToEmails: state => {
        return state.toEmails
    },
    getBCCsEmails: state => {
        return state.bccsEmails
    },
    getSubject: state => {
        return state.subject
    },
    getAttachments: state => {
        return state.attachments
    },
    getSmsTextMaxLength: state => {
        return state.smsTextMaxLength
    },
    getEmailBody: state => {
        return state.emailBody
    },
    getSmsBody: state => {
        return state.smsBody
    },
    getAll: state => {
        return {
            emailTemplate: state.emailTemplate,
            smsTemplate: state.smsTemplate,
            sendEmail: state.sendEmail,
            sendSms: state.sendSms,
            delaySending: state.delaySending,
            sendAt: state.sendAt,
            fromEmail: state.fromEmail,
            toEmails: state.toEmails,
            ccEmails: state.ccEmails,
            bccsEmails: state.bccsEmails,
            subject: state.subject,
            smsTextMaxLength: state.smsTextMaxLength,
            emailBody: state.emailBody,
            smsBody: state.smsBody,
        }
    },
}

const mutations = {
    setEmailTemplate(state, data) {
        state.emailTemplate = data
    },
    setSmsTemplate(state, data) {
        state.smsTemplate = data
    },
    setSendEmail(state, data) {
        state.sendEmail = data
    },
    setSendSms(state, data) {
        state.sendSms = data
    },
    setDelaySending(state, data) {
        state.delaySending = data
    },
    setSendAt(state, data) {
        state.sendAt = data
    },
    setFromEmail(state, data) {
        state.fromEmail = data
    },
    setToEmails(state, data) {
        state.toEmails = data
    },
    setCCEmails(state, data) {
        state.bccsEmails = data
    },
    setBCCsEmails(state, data) {
        state.bccsEmails = data
    },
    setSubject(state, data) {
        state.subject = data
    },
    setAttachments(state, data) {
        state.attachments = data
    },
    setSmsTextMaxLength(state, data) {
        state.smsTextMaxLength = data
    },
    setEmailBody(state, data) {
        state.emailBody = data
    },
    setSmsBody(state, data) {
        state.smsBody = data
    },
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    setEmailTemplate({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setEmailTemplate", data)
        })
    },
    setSmsTemplate({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setSmsTemplate", data)
        })
    },
    setSendEmail({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setSendEmail", data)
        })
    },
    setSendSms({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setSendSms", data)
        })
    },
    setDelaySending({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setDelaySending", data)
        })
    },
    setSendAt({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setSendAt", data)
        })
    },
    setFromEmail({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setFromEmail", data)
        })
    },
    setToEmails({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setToEmails", data)
        })
    },
    setCCEmails({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setCCEmails", data)
        })
    },
    setBCCsEmails({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setBCCsEmails", data)
        })
    },
    setSubject({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setSubject", data)
        })
    },
    setAttachments({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setAttachments", data)
        })
    },
    setSmsTextMaxLength({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setSmsTextMaxLength", data)
        })
    },
    setEmailBody({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setEmailBody", data)
        })
    },
    setSmsBody({dispatch, commit, state}, data) {
        return new Promise((resolve, reject) => {
            commit("setSmsBody", data)
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
